<template>
  <div class="customer-User-manage-box">
    <div class="customer-User-condition-box">
      <el-form :inline="true" :model="condition" size="small">
        <el-form-item label="用户账号">
          <el-input class="customer-user-condition-box-input" v-model.trim="condition.name" placeholder="用户名称" ></el-input>
        </el-form-item>
        <el-form-item label="用户姓名">
          <el-input class="customer-user-condition-box-input" v-model.trim="condition.realName" placeholder="用户姓名" ></el-input>
        </el-form-item>
        <el-form-item label="角色名称">
          <el-select class="customer-user-condition-box-input" v-model="condition.customerRoleId" >
            <el-option label="全部" :value="null"></el-option>
            <el-option v-for="customerRole in customerRoles" :key="customerRole.id"
                       :label="customerRole.name" :value="customerRole.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select class="customer-user-condition-box-input" v-model="condition.enabled" placeholder="启用状态">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData()" size="small">查找</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="div-hr"></div>
    <div class="op-box">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="add" style="border-radius: 20px">添加</el-button>
      <el-button size="small" type="text" @click="edit"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="修改"></svg-icon></i>&nbsp;<span>修改</span></el-button>
      <el-button size="small" type="text" @click="dialogResetPasswd" style="color: #f8ae35"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="重置密码"></svg-icon></i>&nbsp;重置密码</el-button>
      <el-button size="small" type="text" @click="disable" style="color:#f1521b;"><i><svg-icon style="width:1.2em; height: 1.2em" icon-class="停用"></svg-icon></i>&nbsp;停用</el-button>
    </div>
    <flex>
      <el-table class="customer-User-table" size="small" stripe :data="customerUsers"
                height="100%" width="100%"
                highlight-current-row
                :header-row-style="{color:'black'}"
                @row-click="currClick">

        <el-table-column
                prop="name"
                align="center"
                label="用户账号">
        </el-table-column>
        <el-table-column
                prop="customerRoleIds"
                align="center"
                label="角色">
          <template slot-scope="scope">
            <span>{{ getCustomerRoleNamesByIds(scope.row.customerRoleIds) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="enabled"
                align="center"
                label="启用状态">
          <template slot-scope="scope">
            <span>{{ scope.row.enabled === 1 ? '启用': '停用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="realName"
                align="center"
                label="用户姓名">
        </el-table-column>

        <el-table-column
                prop="mobile"
                align="center"
                label="手机">
        </el-table-column>
        <el-table-column
                prop="email"
                align="center"
                label="电子邮箱">
        </el-table-column>
        <el-table-column
                prop="alarmReceivingMode"
                align="center"
                label="报警接收方式">
          <template slot-scope="scope">
            <span>{{ receivingModeMap[scope.row.alarmReceivingMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="reportReceivingMode"
                align="center"
                label="报表接收方式">
          <template slot-scope="scope">
            <span>{{ receivingModeMap[scope.row.reportReceivingMode] }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="deadline"
                align="center"
                label="有效截止日期">
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.deadline) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                prop="note"
                align="center"
                label="备注">
        </el-table-column>
      </el-table>
    </flex>
    <div class="customer-User-page-box">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </div>

    <el-dialog
            :visible.sync="dialogVisible"
            top="15vh"
            size="small"
            width="36.375rem"
            v-if="dialogVisible"
    >
      <template slot="title">
        {{ typeof currCustomerUser.id === 'undefined' || currCustomerUser.id === null || currCustomerUser.id === '' ? '添加': '编辑'}}用户
      </template>

      <div class="edit-customer-user-box" style="display: flex; justify-content: center">
        <el-form ref="form" :model="currCustomerUser" :rules="rules" label-width="8rem" size="small">
          <div class="item-group">
            <el-form-item label="用户账号" prop="name">
              <el-input v-model="currCustomerUser.name"></el-input>
            </el-form-item>
            <el-form-item label="用户姓名" prop="realName">
              <el-input v-model="currCustomerUser.realName" @blur="currCustomerUser.realName = currCustomerUser.realName.replace(/\s/g,'')"></el-input>
            </el-form-item>
          </div>

          <div class="item-group" v-if="typeof currCustomerUser.id === 'undefined' || currCustomerUser.id === null || currCustomerUser.length === 0">
            <el-form-item label="输入密码" prop="password">
              <el-input type="password" v-model="currCustomerUser.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPassword">
              <el-input type="password" v-model="currCustomerUser.checkPassword"></el-input>
            </el-form-item>
          </div>

          <div class="item-group">
            <el-form-item label="分配角色" prop="customerRoleIds">
              <el-select v-model="currCustomerUser.customerRoleIds" multiple>
                <el-option v-for="customerRole in customerRoles" :key="customerRole.id" :disabled="customerRole.enabled === 0"
                           :label="customerRole.name" :value="customerRole.id">

                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="启用状态">
              <el-select v-model="currCustomerUser.enabled" placeholder="启用状态">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="item-group">
            <el-form-item label="手机" prop="mobile">
              <el-input v-model="currCustomerUser.mobile"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input type="email" v-model="currCustomerUser.email"></el-input>
            </el-form-item>
          </div>

          <div class="item-group">
            <el-form-item label="报警接收方式" prop="alarmReceivingMode">
              <el-select v-model="currCustomerUser.alarmReceivingMode">
                <el-option label="不接收" :value="0"></el-option>
                <el-option label="短信" :value="1"></el-option>
                <el-option label="邮件" :value="2"></el-option>
                <el-option label="短信+邮件" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报表接收方式" prop="reportReceivingMode">
              <el-select v-model="currCustomerUser.reportReceivingMode">
                <el-option label="不接收" :value="0"></el-option>
                <el-option label="邮件" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="item-group">
            <el-form-item label="有效截止日期" prop="deadline">
              <el-date-picker
                      style="width: 12.5rem"
                      class="date-picker"
                      v-model="currCustomerUser.deadline"
                      type="date"
                      placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>

          <el-form-item label="备注" prop="note">
            <el-input type="textarea"  v-model="currCustomerUser.note"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="save" size="small">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog
            :visible.sync="resetDialogVisible"
            top="15vh"
            width="34.375rem"
            size="small"
    >
      <template slot="title">
        重置密码
      </template>

      <div style="display: flex; justify-content: center">
        <el-form ref="resetForm" :model="resetCustomerUser" :rules="resetRules" label-width="6.875rem" size="small">

          <!--<div class="item-group">-->
            <el-form-item label="输入新密码" prop="password">
              <el-input type="password" v-model="resetCustomerUser.password"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPassword">
              <el-input type="password" v-model="resetCustomerUser.checkPassword"></el-input>
            </el-form-item>
          <!--</div>-->

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="resetPasswd" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getCustomerUsers, saveCustomerUser, updateCustomerUserSimp, verifyCustomerUser } from '@/api/customerUser'
  import { getCustomerRoles } from '@/api/customerRole'
  import { getCurrDayZero, getCurrDayLast, format } from '@/utils/time'
  import { mapGetters } from 'vuex'
  import { Message, MessageBox } from 'element-ui'
  import { identifierRegex, mobileRegex, emailRegex } from '@/utils/validate'
  import Flex from '@/components/Flex'
  export default {
    name: 'UserManage',
    components: {
      'flex': Flex
    },
    data() {
      var validatePass = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.currCustomerUser.checkPassword !== '' && typeof this.currCustomerUser.checkPassword !== 'undefined' && this.currCustomerUser.checkPassword !== null) {
            this.$refs.form.validateField('checkPassword')
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.currCustomerUser.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }

      var resetValidatePass = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.resetCustomerUser.checkPassword !== '' && typeof this.resetCustomerUser.checkPassword !== 'undefined' && this.resetCustomerUser.checkPassword !== null) {
            this.$refs.resetForm.validateField('checkPassword')
          }
          callback()
        }
      }
      var resetValidatePass2 = (rule, value, callback) => {
        if (typeof value === 'undefined' || value === null || value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.resetCustomerUser.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        receivingModeMap: {
          0: '不接收',
          1: '短信',
          2: '邮件',
          3: '短信+邮件'
        },
        pickerOptions: {
        },
        currentPage: 1,
        pagesize: 10,
        page: {},
        chooseTimes: [new Date(getCurrDayZero()), new Date(getCurrDayLast())],
        customerUsers: [],
        customerRoles: [],
        customerRoleMap: {},
        condition: {
          customerId: null,
          userType: 0,
          name: null,
          realName: null,
          enabled: 1,
          customerRoleId: null
        },
        // 添加编辑
        currCustomerUser: {},
        dialogVisible: false,
        rules: {
          name: [{ required: true, pattern: identifierRegex, message: '请输入正确的用户账号', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          realName: [{ required: true, message: '用户姓名必填', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          password: [{ validator: validatePass, required: true, trigger: 'blur' }, { pattern: /^(?=.*\d)(?=.*[a-zA-Z]).+$/, message: '必须包含字母和数字', trigger: 'blur' }, { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
          checkPassword: [{ validator: validatePass2, required: true, trigger: 'blur' }],
          customerRoleIds: [{ required: true, message: '角色必选', trigger: 'change' }],
          enabled: [{ required: true, message: '启用状态必选', trigger: 'blur' }],
          mobile: [{ required: true, pattern: mobileRegex, message: '请输入正确的手机号', trigger: 'blur' }, { min: 11, max: 11, message: '长度为 11 个字符', trigger: 'blur' }],
          email: [{ required: true, pattern: emailRegex, message: '请输入正确的电子邮箱', trigger: 'blur' }, { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
          deadline: [{ required: true, message: '有效截止日期必填', trigger: 'blur' }]
        },
        // 重置密码数据
        resetDialogVisible: false,
        resetCustomerUser: [],
        resetRules: {
          password: [{ validator: resetValidatePass, required: true, trigger: 'blur' }, { pattern: /^(?=.*\d)(?=.*[a-zA-Z]).+$/, message: '必须包含字母和数字', trigger: 'blur' }, { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
          checkPassword: [{ validator: resetValidatePass2, required: true, trigger: 'blur' }]
        }
      }
    },
    computed: {
      ...mapGetters([
        'customerId'
      ])
    },
    mounted() {
      this.fetchAllCustomerRoles()
      this.fetchData()
    },
    methods: {
      fetchData: function(isPage) {
        // 空字符串设为null
        if (this.condition.name !== null && this.condition.name.length === 0) {
          this.condition.name = null
        }

        if (this.condition.realName !== null && this.condition.realName.length === 0) {
          this.condition.realName = null
        }
        // 角色条件非空加入
        this.condition.customerRoleIds = null
        if (this.condition.customerRoleId !== null && this.condition.customerRoleId.length > 0) {
          this.condition.customerRoleIds = [this.condition.customerRoleId]
        }
        this.condition.customerId = this.customerId
        if (this.page.total) this.page.total = null
        if (!isPage) {
          this.page['current'] = 1
        }
        const myPage = { page: this.page, condition: this.condition }
        getCustomerUsers(myPage).then(res => {
          if (res.code === 200) {
            const page = res.infoJson
            this.customerUsers = page.records
            this.page.total = page.total
          }
        }).catch(error => {
        })
      },
      fetchAllCustomerRoles: function() {
        const condition = { customerId: this.customerId, enabled: null }
        getCustomerRoles(condition).then(res => {
          if (res.code === 200) {
            this.customerRoles = res.infoJson
            const map = {}
            this.customerRoles.forEach(item => {
              map[item.id] = item
            })
            this.customerRoleMap = map
          }
        })
      },
      getCustomerRoleNamesByIds: function(customerRoleIds) {
        const r = []
        if (customerRoleIds && this.customerRoleMap) {
          customerRoleIds.forEach(item => {
            if (this.customerRoleMap[item]) {
              r.push(this.customerRoleMap[item].name)
            }
          })
        }
        return r.join(',')
      },
      formatTime: function(time) {
        if (typeof time !== undefined && time !== null) {
          return format(time, 'YYYY-MM-DD')
        } else {
          return time
        }
      },
      handleSizeChange: function(size) {
        this.page.size = size
        this.fetchData(true)
      },
      handleCurrentChange: function(currentPage) {
        this.page.current = currentPage
        this.fetchData(true)
      },
      currClick: function(val) {
        this.currCustomerUser = Object.assign({}, val)
      },
      edit: function() {
        if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
          Message({
            message: '请选择用户',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      add: function() {
        // this.currCustomerUser.id = null
        this.currCustomerUser = { id: null, enabled: 1, customerId: this.customerId, createDate: new Date(), customerRoleIds: [], mobile: null, email: null, alarmReceivingMode: 0, reportReceivingMode: 0 }
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
        this.dialogVisible = true
      },
      save: function() {
        this.$refs.form.validate(valid => {
          if (valid) {
            verifyCustomerUser(this.currCustomerUser).then(res => {
              if (res.code === 200) {
                if (res.infoJson) {
                  // 系统用户
                  this.currCustomerUser['userType'] = 0
                  saveCustomerUser(this.currCustomerUser).then(res => {
                    if (res.code === 200) {
                      Message({
                        message: '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                      })
                      this.dialogVisible = false
                      this.currCustomerUser = { id: null }
                      this.fetchData(true)
                    } else {
                      Message({
                        message: '操作失败',
                        type: 'error',
                        duration: 5 * 1000
                      })
                    }
                  })
                } else {
                  Message({
                    message: '该用户已存在',
                    type: 'warning',
                    duration: 5 * 1000
                  })
                }
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      disable: function() {
        if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
          Message({
            message: '请选择用户',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        const customerUser = {
          id: this.currCustomerUser.id,
          enabled: 0
        }
        MessageBox.confirm('确定停用该用户？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateCustomerUserSimp(customerUser).then(res => {
            if (res.code === 200) {
              Message({
                message: '操作成功',
                type: 'success',
                duration: 5 * 1000
              })
              this.currCustomerUser = { id: null }
            } else {
              Message({
                message: '操作失败',
                type: 'error',
                duration: 5 * 1000
              })
            }
            this.fetchData()
          })
        })
      },
      dialogResetPasswd: function() {
        if (typeof this.currCustomerUser.id === 'undefined' || this.currCustomerUser.id === null || this.currCustomerUser.id === '') {
          Message({
            message: '请选择用户',
            type: 'warning',
            duration: 5 * 1000
          })
          return
        }
        this.resetCustomerUser = {
          id: this.currCustomerUser.id,
          password: null,
          checkPassword: null
        }
        this.resetDialogVisible = true
      },
      resetPasswd: function() {
        this.$refs.resetForm.validate(valid => {
          if (valid) {
            updateCustomerUserSimp(this.resetCustomerUser).then(res => {
              if (res.code === 200) {
                Message({
                  message: '操作成功',
                  type: 'success',
                  duration: 5 * 1000
                })
                this.resetDialogVisible = false
                this.currCustomerUser = { id: null }
                this.fetchData()
              } else {
                Message({
                  message: '操作失败',
                  type: 'error',
                  duration: 5 * 1000
                })
              }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .customer-User-manage-box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    button {
      /*font-size: 14px;*/
      font-weight: bold;
    }

    .customer-User-condition-box {
      font-size: 14px;
      height: 60px;
      display: flex;
      align-items: center;
      padding-top: 15px;
      padding-left: 20px;
      box-sizing: border-box;
      .customer-user-condition-box-input {
        width: 100px;
      }
      .customer-User-search-button {
        margin-left: 10px;
      }
    }

    .div-hr {
      height: 1px;
      background-color: #dedede;
    }

    .op-box {
      padding-left: 20px;
      padding-top: 15px;
      padding-bottom: 15px;

      button {
        margin-right: 20px;
      }
    }

    .customer-User-page-box {
      height: 45px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .item-group {
      display: flex;
      div {
       padding-right: 10px;
      }
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  .customer-User-manage-box {
    .edit-customer-user-box {
      .el-table th {
        background-color: #f5fafb;
      }
      .el-table__row--striped {
        background-color: #f4f3f3 !important;
      }
      .el-input__inner {
        width: 120px;
      }
      .date-picker  {
        .el-input__inner {
          width: 200px;
        }
      }
    }

    .el-table__body, .el-table__header {
      width: auto !important;
    }
  }
</style>
